import React from 'react';
import styles from './TestimonialCard.module.css';

const TestimonialCard = ({ quote, author, company }) => {
  return (
    <div className={styles.card}>
      <p className={styles.quote}>"{quote}"</p>
      <div className={styles.authorInfo}>
        <span className={styles.author}>{author}</span>
        <span className={styles.company}>{company}</span>
      </div>
    </div>
  );
};

export default TestimonialCard;
